import * as React from 'react';
import {DefaultButton, Dropdown, PrimaryButton} from '@fluentui/react';
import { Panel } from '@fluentui/react';
import {useContext, useEffect, useState} from "react";
import {Stack} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";

function AddUserVentureRestriction(props) {
    const [user] = useContext(AuthContext);
    const [venture, setVenture] = useState('');
    const [ventures, setVentures] = useState([]);

    const _submit = (e) => {
        e.preventDefault();
        const data = {venture_id: venture.key};
        fetch(`/api/user/${props.add}/venture`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddUserVentureRestriction'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        const abortController = new AbortController();
        setVenture('');
        if (props.add) {
            async function fetchData() {
                await fetch(`/api/venture`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => {
                        setVentures(data.map((item) => {
                            return {key: item.id, text: item.name};
                        }))
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
            fetchData();
        }
        return () => abortController.abort();
    }, [props.add, user.token])


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Ograniczenie Kontraktu"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddUserVentureRestriction'>
                <Dropdown
                    label="Kontrakt"
                    selectedKey={venture ? venture.key : undefined}
                    onChange={(e, item) => setVenture(item)}
                    placeholder="Wybierz z listy"
                    options={ventures}
                />
            </form>
        </Panel>
    )
}

export default AddUserVentureRestriction;